import InternalLinkComponent, { InternalLinkProps } from "./InternalLink";
import ExternalLinkComponent, { ExternalLinkProps } from "./ExternalLink";
import { Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const InternalLink = InternalLinkComponent as any;
const ExternalLink = ExternalLinkComponent as any;

export type GoBackProps = InternalLinkProps | ExternalLinkProps;

const GoBack: React.FC<GoBackProps> = (props) => {
  return (
    <Container>
      {props._type == "internalLink" && <InternalLink {...props} />}
      {props._type == "externalLink" && <ExternalLink {...props} />}
    </Container>
  );
};

export default GoBack;
